<template>
    <div class='layerWrap' style='display:block; background-color: #0d0d0d66;'>
        <div class='layerRow'>
            <div class='layerCell'>
                <div class='layerIn'>
                    <img class='comingSoonImg' src='@/assets/img/ic_not_open.png' v-if="comingSoonFlag && imgFlag == undefined"/>
                    <img class='img'  src='@/assets/img/ic_complete_60.png' v-else-if="!comingSoonFlag && imgFlag == undefined"/>
                    <!-- Title -->
                    <div
                        v-if='message.title'
                        class='layerHd'>
                        <h1 class='hTit'>{{$t(`${message.title ? message.title: ''}`)}}</h1>
                    </div>
                    <!-- Content -->
                    <div class='layerCnt'>
                        <div class='lyIn'>
                            {{$t(`${message.msg[0] ? message.msg[0]: ''}`)}}<br v-if='checkStringData($t(`${message.msg[0]}`))'/>
                            <strong>{{$t(`${message.msg[1] ? message.msg[1]: ''}`)}}</strong>
                            {{$t(`${message.msg[2]? message.msg[2]: ''}`)}}
                            <br/>
                            {{$t(`${message.msg[3]? message.msg[3]: ''}`)}}
                        </div>
                    </div>
                    <!-- 확인 버튼 -->
                    <div class='layerBtm'>
                        <ul>
                            <li>
                                <button
                                    @click.stop.prevent='onClickConfirmBtn'
                                    type='button'
                                    class='btn'>
                                    확인
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="js">
import { SINGLE_BUTTON_DIALOG } from '@/utils/EndPoint'
import { MESSAGE_SINGLE_BUTTON } from '@/utils/Message'
import Vue from 'vue'
export default Vue.extend({
  name: SINGLE_BUTTON_DIALOG,
  props: [
    'messageType', // message type 번호
    'onClickConfirmBtn', // 확인 버튼 클릭 Event
    'comingSoonFlag',
    'imgFlag'
  ],
  data () {
    return {
      message: MESSAGE_SINGLE_BUTTON[this.messageType]
    }
  },
  mounted () { this.addDimForDialog() },
  destroyed () { this.removeDimForDialog() }
})
</script>
